import { render, staticRenderFns } from "./shareStu.vue?vue&type=template&id=229fdf78&scoped=true&"
import script from "./shareStu.vue?vue&type=script&lang=js&"
export * from "./shareStu.vue?vue&type=script&lang=js&"
import style0 from "./shareStu.vue?vue&type=style&index=0&id=229fdf78&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229fdf78",
  null
  
)

export default component.exports